import 'whatwg-fetch';

const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;
const apiUrl = process.env.REACT_APP_API_URL;

export const secondaryMenuApi = {
    fetch: async () => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
        }).toString();

        const response = await fetch(
            `${apiUrl}/wp-json/app/v1/menu/secondary?${queryParams}`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    },
};
